import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { getAdminRoleApi } from '@/api/login'
import { transformMenuToRoute } from '@/utils/routerHelper'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      const addRouters = permissionStore.getAddRouters || []
      const hasTargetRoute =
        (to.name && router.hasRoute(to.name)) ||
        router.getRoutes().some((item) => item.path === to.path)
      const hasAddRouters =
        addRouters.length > 0 &&
        addRouters.some((route) => {
          if (route.name && router.hasRoute(route.name as string)) {
            return true
          }
          return router.getRoutes().some((item) => item.path === route.path)
        })

      if (permissionStore.getIsAddRouters && hasAddRouters && hasTargetRoute) {
        next()
        return
      }

      // 开发者可根据实际情况进行修改
      let roleRouters = userStore.getRoleRouters || []

      // 是否使用动态路由
      if (appStore.getDynamicRouter) {
        if (appStore.getServerDynamicRouter) {
          const res = await getAdminRoleApi().catch(() => undefined)
          if (res && res.data) {
            roleRouters = transformMenuToRoute(res.data as any)
            userStore.setRoleRouters(roleRouters as AppCustomRouteRecordRaw[])
          }
          await permissionStore.generateRoutes('server', roleRouters as AppCustomRouteRecordRaw[])
        } else {
          await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
        }
      } else {
        await permissionStore.generateRoutes('static')
      }

      permissionStore.getAddRouters.forEach((route) => {
        if (route.name && router.hasRoute(route.name as string)) {
          return
        }
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      if (!hasTargetRoute) {
        next({ ...to, replace: true })
        return
      }
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
